<template>
  <footer class="footer dashboard-footer" style="flex:1">
    <div class="columns" style="margin-left:105px; margin-right:10px;">
      <div class="column is-2">
        <strong><p>OIS MEDIA</p></strong>
        <p class="help has-text-light">Impressum</p>
        <p class="help has-text-light">AGB</p>
        <p class="help has-text-light">Datenschutz</p>
        <p class="help has-text-light">Kontakt</p>
      </div>
      <div class="column is-2">
        <strong><p>HILFE</p></strong>
        <p class="help has-text-light">Dokumentation</p>
        <p class="help has-text-light">FAQ</p>
        <p class="help has-text-light">Supportanfrage</p>
      </div>
      <div class="column">
        <strong><p>LINKS</p></strong>
        <p class="help has-text-light">Account</p>
        <p class="help has-text-light">Katalog</p>
        <p class="help has-text-light">Logout</p>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style scoped>

  .dashboard-footer {
    background-color: #16232A;
    padding-bottom: 3rem;
  }

  /* Column headings were dark-on-black before — lift them to a readable label */
  .dashboard-footer strong p {
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    margin-bottom: 0.85rem;
  }

  .dashboard-footer .help {
    color: rgba(255, 255, 255, 0.55) !important;
    font-size: 0.85rem;
    margin-bottom: 0.4rem;
    transition: color 0.16s ease;
  }

  .dashboard-footer .help:hover {
    color: #fff !important;
    cursor: pointer;
  }

</style>
